import React from 'react';
import {
  Typography,
  LinearProgress,
} from '@material-ui/core';

import './Progress.scss';



export default function Progress() { 
  return (
    <div id="modal">
      <div id="progress-cont">
        <Typography>Loading resources ...</Typography>
        <LinearProgress variant="indeterminate" />
      </div>
    </div>
  );
}